/** Centralized user-facing sidebar / navigation copy. */
export const SIDEBAR_TEXTS = {
  nav: {
    streamStats: "Stream Stats",
    news: "News",
    slots: "Slots",
    liveCasino: "Live Casino",
    crashGames: "Crash Games",
    roadmaps: "Roadmaps",
  },

  sections: {
    games: "Games",
  },

  backOffice: {
    manageStreamers: "Manage Streamers",
    manageAdmins: "Manage Admins",
    reports: "Reports",
  },
} as const
